// extracted by mini-css-extract-plugin
export default {"revenue_box":"RevenueBox_revenue_box__EPZ0e","revenue_title":"RevenueBox_revenue_title__RuGVs","revenue_value":"RevenueBox_revenue_value__7ZaDH"};